import { render, staticRenderFns } from "./content.vue?vue&type=template&id=1042fa93&scoped=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"
import style0 from "./content.vue?vue&type=style&index=0&id=1042fa93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1042fa93",
  null
  
)

export default component.exports